// extracted by mini-css-extract-plugin
export default {"backgroundBox":"Background_backgroundBox__FpJfk","imageWrapper":"Background_imageWrapper__GwBbV","image":"Background_image__rCtAE"};